// @flow
import React, { Component } from 'react'
import moment from 'moment'
// $FlowFixMe
import { Field, reduxForm } from 'redux-form'
// $FlowFixMe
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { locationsFetchRequest } from '../../ducks/locations/index'
import { Button, Title, YellowPattern, GreenPattern, NewLogo } from 'src/theme/globalStyle'
import {
  FieldCollection,
  FormField,
  Label,
  Error,
  Checkbox,
  Check,
  Radiomark,
  StyledField,
  StyledForm,
  StyledFormInfo,
  StyledRadio
} from 'src/components/Form'
import { LoadingCircle, Tick } from 'src/components/Icons'
import { NavBar } from 'src/components/NavBar'
import { CORPORATION_OPTIONS, SALES_OPTIONS } from 'src/helpers/constants'
import {
  renderError,
  renderField,
  renderPhone,
  renderRadio,
  renderNativeSelect,
  renderSelect,
  renderSequentialDatePicker
} from 'src/helpers/fieldRenderers'
import { required, validateAdmin, validateFloor } from 'src/helpers/validation'
import { greaterThanZero, normalizeSelect } from 'src/helpers/normalize'
import { encryptValues } from 'src/ducks/encryption'
import { authenticationRequest } from 'src/ducks/auth'
import {
  StyledAdmin,
  LoadingContainer,
  StyledArticle,
  RadioBox,
  OtherContainer,
  StyledButton,
  StyledA,
  RadioContainer,
  CopyFieldContainer,
  StyledUrl
} from './StyledElements'
import type { Props, State } from './types'
import { adminFormFieldOrdered, getDuration } from './helpers'

class AdminFormComponent extends Component<Props, State> {
  state = { isCopied: false }
  componentDidMount() {
    this.props.dispatch(locationsFetchRequest())
  }
  getFloorPreferences = (ref: any) => {
    const rr = ref.value || ref
    const roomTypes = this.getActiveParam('roomTypes')
    const floors = this.getActiveParam('floorPreferences')
    const roomType = roomTypes && roomTypes.find(r => r.ref === rr)
    if (roomType && roomType.floorPreference) {
      return roomType.floorPreference.map(fRef => (floors ? floors[fRef] : null))
    }
    return null
  }
  // $FlowFixMe
  getOccupancyTypes = ref => {
    const roomTypes = this.getActiveParam('roomTypes')
    const occupancyTypes = this.getActiveParam('occupancyTypes')
    const roomType = roomTypes && roomTypes.find(r => r.ref === ref)
    if (roomType && roomType.occupancyTypes) {
      return roomType.occupancyTypes.map(fRef => (occupancyTypes ? occupancyTypes[fRef] : null))
    }
    return []
  }
  // $FlowFixMe
  getActiveParam = param => {
    const { availableLocations, location } = this.props
    if ((location && location.value) || typeof location === 'string') {
      const selected = availableLocations.find(l => l.ref === location.value || l.ref === location)
      return selected[param]
    }
    return null
  }
  // $FlowFixMe
  authenticate = e => {
    e.preventDefault()
    e.stopPropagation()
    const { username, password, dispatch } = this.props
    if (username && password) {
      dispatch(authenticationRequest(username, password))
    }
  }
  resetRoomType = () => {
    const { change, dispatch } = this.props
    dispatch(change('roomType', ''))
  }
  // $FlowFixMe
  reflectDeposit = e => {
    const val = e.value
    const roomTypes = this.getActiveParam('roomTypes')
    const roomType = roomTypes && roomTypes.find(r => r.ref === val)
    if (roomType) {
      const { change, dispatch } = this.props
      dispatch(change('bookingDeposit', roomType.deposit))
      dispatch(change('roomPrice', roomType.basePrice))
      dispatch(change('occupancyType', 'single'))
    }
  }

  onRestrictionChange = () => {
    //do nothing
  }
  // $FlowFixMe
  reflectFloorSelection = (e, roomVal) => {
    const val = e.value || e
    const floorPreferences = this.getActiveParam('floorPreferences')
    const floorPreference = floorPreferences && floorPreferences[val]
    const roomTypes = this.getActiveParam('roomTypes')
    const roomType = roomTypes && roomTypes.find(r => r.ref === (roomVal.value || roomVal))
    if (floorPreference && roomType) {
      const { change, dispatch } = this.props
      dispatch(
        change(
          'bookingDeposit',
          parseInt(roomType.deposit, 10) + parseInt(floorPreference.premium, 10)
        )
      )
      dispatch(
        change('roomPrice', parseInt(roomType.deposit, 10) + parseInt(floorPreference.premium, 10))
      )
    }
  }
  // $FlowFixMe
  _handleSubmit = values => {
    const { dispatch, reset } = this.props
    delete values.username
    delete values.password
    const mq = window.matchMedia('(min-width: 480px)')
    if (mq.matches) {
      window.scrollTo(0, 0)
    }
    Object.keys(values).map(key => {
      if (
        {
          location: '',
          roomType: '',
          yourName: '',
          currency: ''
        }.hasOwnProperty(key)
      ) {
        values[key] = typeof values[key] === 'string' ? values[key] : values[key].value
      }
      return true
    })
    values['moveIn'] = JSON.stringify(values['moveIn']) //
    values['restrictedDuration'] =
      values['restrictedDuration'] && JSON.stringify(values['restrictedDuration'])
    values['preferredFloor'] =
      values['preferredFloor'].value === '' ? '' : JSON.stringify(values['preferredFloor'])
    values['createdAt'] = moment.utc(Date.now()).valueOf()
    values['digitalVerification'] = values['digitalVerification'] === 'true'
    dispatch(encryptValues(values))
    reset()
  }
  render() {
    const {
      handleSubmit,
      shortUrl,
      longUrl,
      roomType,
      bookingType,
      corporateContact,
      hasEncrypted,
      authError,
      authenticated,
      isProcessing,
      bookingDepositEdited,
      roomPriceEdited,
      availableLocations,
      location
    } = this.props

    const { isCopied } = this.state
    const roomTypes = this.getActiveParam('roomTypes')
    const roomOptions = roomTypes
      ? roomTypes.map(r => ({
          label: r.name,
          value: r.ref
        }))
      : []
    const mq = window.matchMedia('(min-width: 480px)')
    const showLoading = isProcessing && !hasEncrypted

    let restrictedDurationOptions: Array<{ label: string, value: number }>
    if (location) {
      restrictedDurationOptions = [
        { label: 'Unrestricted', value: -1 },
        ...getDuration('unrestricted', {
          ...location,
          ref: location && location.value
        })
      ]
    }

    return (
      <StyledAdmin>
        <NewLogo />
        <YellowPattern />
        <GreenPattern />
        {showLoading && (
          <LoadingContainer>
            <LoadingCircle />
          </LoadingContainer>
        )}
        {authenticated && <NavBar title={'Admin'} noTopBar />}
        {!showLoading && authenticated && (
          <StyledArticle>
            <StyledForm onSubmit={handleSubmit(this._handleSubmit)}>
              <FieldCollection hasShadow>
                <Title>Room Details</Title>
                <div id="location-field">
                  <Field
                    name="location"
                    component={mq.matches ? renderSelect : renderNativeSelect}
                    options={availableLocations.map(l => ({ label: l.name, value: l.ref }))}
                    label="Location"
                    onChange={this.resetRoomType}
                    validate={[required]}
                    required
                    normalize={normalizeSelect}
                  />
                </div>
                {this.getActiveParam('hasBookingTypes') && (
                  <FormField noBorder={true}>
                    <Label>Application Type</Label>
                    <RadioBox id="Co-living">
                      <Field
                        name="bookingType"
                        component={renderRadio}
                        fixedValue="co-living"
                        label="Co-living"
                      />
                      <Field
                        name="bookingType"
                        component={renderRadio}
                        fixedValue="corporate"
                        label="Corporate"
                      />
                    </RadioBox>
                    <Field name="bookingType" hideArrow component={renderError} />
                  </FormField>
                )}
                {bookingType === 'corporate' && (
                  <Field
                    name="corporate_contact"
                    component={mq.matches ? renderSelect : renderNativeSelect}
                    options={CORPORATION_OPTIONS}
                    label="Corporation"
                    validate={[required]}
                    required
                    normalize={normalizeSelect}
                  />
                )}
                {bookingType === 'corporate' &&
                  corporateContact &&
                  corporateContact.value === '+' && <br />}
                {bookingType === 'corporate' &&
                  corporateContact &&
                  corporateContact.value === '+' && <Label>Add New</Label>}
                {bookingType === 'corporate' && corporateContact && corporateContact.value === '+' && (
                  <OtherContainer>
                    <Field
                      name="bookingType_Name"
                      type="text"
                      component={renderField}
                      label="Name Of Corporation"
                    />
                    <Field
                      name="bookingType_Address"
                      type="text"
                      component={renderField}
                      label="Company Registration Address"
                    />
                    <Field
                      name="bookingType_RegNumber"
                      type="text"
                      component={renderField}
                      label="Company Registration Number "
                    />
                    <Field
                      name="bookingType_website"
                      type="text"
                      component={renderField}
                      label="Corporation Website"
                    />
                    <Field
                      name="bookingType_contactName"
                      type="text"
                      component={renderField}
                      label="Name Of Contact Person In Corporation"
                    />
                    <Field
                      name="bookingType_contactEmail"
                      type="text"
                      component={renderField}
                      label="Email Of The Contact Person"
                    />
                    <Field
                      name="bookingType_contactPhone"
                      type="text"
                      component={renderPhone}
                      label="Phone Of The Contact Person"
                    />
                  </OtherContainer>
                )}
                <div id="room-type-field">
                  <Field
                    name="roomType"
                    component={mq.matches ? renderSelect : renderNativeSelect}
                    label="Room Type"
                    id="room-type"
                    className="room-type"
                    onChange={this.reflectDeposit}
                    validate={[required]}
                    options={roomOptions}
                    required
                    normalize={normalizeSelect}
                  />
                </div>
                <div id="location-field">
                  <Field
                    name="yourName"
                    component={mq.matches ? renderSelect : renderNativeSelect}
                    options={SALES_OPTIONS}
                    label="Your Name"
                    id="your-name"
                    required
                    validate={[required]}
                    normalize={normalizeSelect}
                  />
                </div>
                {roomType &&
                  (typeof roomType === 'string' || roomType.value) &&
                  this.getFloorPreferences(roomType) && (
                    <div id="floor-field">
                      <Field
                        name="preferredFloor"
                        component={mq.matches ? renderSelect : renderNativeSelect}
                        options={this.getFloorPreferences(roomType)}
                        label="Preferred Floor"
                        id="preferred-floor"
                        onChange={e => this.reflectFloorSelection(e, roomType)}
                        validate={[required, validateFloor('roomType')]}
                        required
                        normalize={normalizeSelect}
                      />
                    </div>
                  )}
                <div id="move-in-date-field">
                  <Field
                    name="moveIn"
                    type="text"
                    id="move-in-date"
                    required
                    component={renderSequentialDatePicker}
                    label="Wanted move-in date"
                    validate={[required]}
                  />
                </div>
                {roomType &&
                  roomType.value &&
                  this.getOccupancyTypes(roomType.value) &&
                  this.getOccupancyTypes(roomType.value).length > 0 && (
                    <FormField noBorder={true}>
                      <Label moreMargin>Type of occupancy</Label>
                      <RadioBox>
                        {this.getOccupancyTypes(roomType.value).map((o, i) => (
                          <StyledRadio key={i}>
                            <Field
                              name="occupancyType"
                              component="input"
                              type="radio"
                              value={o.value}
                            />
                            <Radiomark />
                            {o.label}
                          </StyledRadio>
                        ))}
                      </RadioBox>
                      <Field name="occupancyType" hideArrow component={renderError} />
                    </FormField>
                  )}
                <FormField noBorder={true}>
                  <Label moreMargin>Digital Verification</Label>
                  <RadioBox>
                    <StyledRadio>
                      <Field
                        name="digitalVerification"
                        component="input"
                        type="radio"
                        value="true"
                      />
                      <Radiomark id="dgv_yes" />
                      Yes
                    </StyledRadio>
                    <StyledRadio>
                      <Field
                        name="digitalVerification"
                        component="input"
                        type="radio"
                        value="false"
                      />
                      <Radiomark id="dgv_no" />
                      No
                    </StyledRadio>
                  </RadioBox>
                  <Field name="digitalVerification" hideArrow component={renderError} />
                </FormField>
              </FieldCollection>
              <FieldCollection hasShadow>
                <Title>Customise</Title>
                <FormField>
                  <Label>Allow Payment In Person</Label>
                  <Checkbox>
                    <Field name="allow_cash" type="checkbox" component="input" />
                    <Check />
                    <StyledButton type="button">
                      <StyledA>Yes</StyledA>{' '}
                    </StyledButton>
                  </Checkbox>
                </FormField>
                <FormField>
                  <Field
                    name="bookingDeposit"
                    type="number"
                    component={renderField}
                    disabled={bookingDepositEdited !== true}
                    label="Holding Deposit"
                    pushSuffix
                    secondLabel="Amount in GBP - The number input is amount charged as holding deposit and will not affect the security bond"
                    disabledSuffix=" - not editable unless enabled"
                  />
                  <Checkbox>
                    <Field name="bookingDepositEdited" type="checkbox" component="input" />
                    <Check />
                    <StyledButton type="button">
                      <StyledA>Edit Holding Deposit</StyledA>{' '}
                    </StyledButton>
                  </Checkbox>
                  <Field
                    name="adminFee"
                    type="number"
                    component={renderField}
                    validate={[required]}
                    label="Membership Joining Fee"
                    secondLabel="Amount in GBP - if n/a input zero (£0)"
                    normalize={greaterThanZero}
                  />
                  <Field
                    name="roomPrice"
                    type="number"
                    component={renderField}
                    disabledSuffix=" - not editable unless enabled"
                    label="Licence fee – 12 Membership Period"
                    disabled={roomPriceEdited !== true}
                    normalize={greaterThanZero}
                  />
                  <Checkbox>
                    <Field name="roomPriceEdited" type="checkbox" component="input" />
                    <Check />
                    <StyledButton type="button">
                      <StyledA>Edit Licence Fee</StyledA>{' '}
                    </StyledButton>
                  </Checkbox>
                </FormField>
                {/* {this.getActiveParam('canRestrictDuration') && ( */}
                <RadioContainer>
                  {/*<Label moreMargin>Restrict membership period selection?</Label>
                   <RadioBox>
                    <StyledRadio>
                      <Field
                        name="hasRestrictedDuration"
                        component="input"
                        type="radio"
                        value="unrestricted"
                        onChange={e => this.onRestrictionChange(e)}
                      />
                      <Radiomark />
                      Unrestricted
                    </StyledRadio>
                    <StyledRadio>
                      <Field
                        name="hasRestrictedDuration"
                        component="input"
                        type="radio"
                        value="restricted"
                        onChange={e => this.onRestrictionChange(e)}
                      />
                      <Radiomark />
                      Restricted
                    </StyledRadio>
                    <StyledRadio>
                      <Field
                        name="hasRestrictedDuration"
                        component="input"
                        type="radio"
                        value="semi"
                        onChange={e => this.onRestrictionChange(e)}
                      />
                      <Radiomark />
                      Semi-restricted
                    </StyledRadio>
                  </RadioBox> */}
                  <Field
                    name="restrictedDuration"
                    component={mq.matches ? renderSelect : renderNativeSelect}
                    options={restrictedDurationOptions}
                    label="Restrict membership period selection?"

                    // validate={[required]}
                    // required
                    // normalize={normalizeSelect}
                  />
                </RadioContainer>
                {/* )} */}
                <br />
                <Button type="submit" uppercase>
                  Generate URL
                </Button>
              </FieldCollection>
            </StyledForm>
            <StyledFormInfo>
              <div style={{ padding: '10px 40px 40px 40px' }}>
                <Title>URL</Title>
                <FormField>
                  <Label>Share Your Application Link</Label>
                  <CopyFieldContainer>
                    <StyledField fullWidth>
                      <StyledUrl>
                        {process.env.NODE_ENV === 'production' ? shortUrl : longUrl}
                      </StyledUrl>
                    </StyledField>
                    <br />
                    <CopyToClipboard
                      text={process.env.NODE_ENV === 'production' ? shortUrl : longUrl}
                      onCopy={() => {
                        this.setState({ isCopied: true })
                        setTimeout(() => this.setState({ isCopied: false }), 3000)
                      }}
                    >
                      <Button copy uppercase>
                        {isCopied ? <Tick color="#fff" /> : 'Copy URL'}
                      </Button>
                    </CopyToClipboard>
                  </CopyFieldContainer>
                </FormField>
                {(shortUrl || longUrl) && (
                  <FormField>
                    <Button
                      onClick={() =>
                        window.open(
                          process.env.NODE_ENV === 'production' ? shortUrl : longUrl,
                          '_blank'
                        )
                      }
                      uppercase
                    >
                      Open Link
                    </Button>
                  </FormField>
                )}
              </div>
            </StyledFormInfo>
          </StyledArticle>
        )}
        {!authenticated && (
          <StyledForm style={{ maxWidth: '500px' }} onSubmit={() => {}}>
            <FieldCollection
              hasShadow
              style={{ padding: '50px 30px', marginTop: '100px', backgroundColor: 'white' }}
            >
              <Title style={{ textAlign: 'center' }}>Admin Login</Title>
              <FormField>
                <Field
                  name="username"
                  type="text"
                  component={renderField}
                  validate={[required]}
                  label="Username"
                />
              </FormField>
              <FormField>
                <Field
                  name="password"
                  type="password"
                  autocomplete="on"
                  component={renderField}
                  validate={[required]}
                  label="Password"
                />
                {authError && <Error hideArrow>{authError}</Error>}
              </FormField>
              <br />
              <br />
              <Button onClick={this.authenticate} uppercase>
                Login
              </Button>
            </FieldCollection>
          </StyledForm>
        )}
      </StyledAdmin>
    )
  }
}
export const AdminForm = reduxForm({
  form: 'adminForm',
  validate: validateAdmin,
  onSubmitFail: errors => {
    let eleFocused = false
    adminFormFieldOrdered.forEach(p => {
      if (errors[p] && !eleFocused) {
        const ele = document.querySelector(`input[name="${p}"]`)
        if (ele) {
          ele.parentElement && ele.parentElement.scrollIntoView
            ? // $FlowFixMe
              ele.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            : ele.focus()
          eleFocused = true
        }
      }
    })
  }
})(AdminFormComponent)



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminForm.js